import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getOutcome } from './result';
import styles from './index.css';

const STATUS_CLASS = {
    '计票中...': 'counting',
    民主党获胜: 'demWin',
    共和党获胜: 'gopWin',
    其他获胜: 'otherWin',
};

const formatUpdate = value => {
    const match = String(value || '').match(/(\d{2}:\d{2})/);
    return match ? `${match[1]}更新` : '';
};

const isSwingState = state => state.swing === '是';

const REFRESH_ICON = 'https://x0.ifengimg.com/ucms/2026_43/5FB02A8F9F59CB0E60CF4AAEA90AD424558311E9_size1_w28_h28.png';

const States = ({ data = [], type = 0, updateTime = '', refreshing = false, onRefresh, onlySwing = false, onOnlySwingChange }) => {
    const byCount = type === 1 || type === 2;
    const isSenate = type === 1;
    const updated = formatUpdate(updateTime);
    const list = isSenate && onlySwing ? data.filter(isSwingState) : data;

    return (
        <section className={styles.card}>
            <div className={styles.head}>
                <div className={styles.title}>各州选情</div>
                <div className={styles.headRight}>
                    {isSenate ? (
                        <div className={styles.keyFilter} onClick={() => onOnlySwingChange && onOnlySwingChange(!onlySwing)}>
                            <span>只看关键州</span>
                            <div className={`${styles.switch} ${onlySwing ? styles.switchOn : ''}`}>
                                <div className={styles.switchThumb} />
                            </div>
                        </div>
                    ) : null}
                    {updated ? (
                        <div className={styles.updated} onClick={onRefresh}>
                            <span>手动刷新</span>
                            <img className={`${styles.refresh} ${refreshing ? styles.refreshing : ''}`} src={REFRESH_ICON} alt="" />
                        </div>
                    ) : null}
                </div>
            </div>
            <ul className={styles.list}>
                {list.map((state, index) => {
                    const total = Number(state.total) || 0;
                    const dem = Number(state.dem) || 0;
                    const gop = Number(state.gop) || 0;
                    const oth = Number(state.oth) || 0;
                    const outcome = getOutcome(state, { byCount });
                    const showSeats = type === 0 || !outcome.single;
                    const statusClass = styles[STATUS_CLASS[outcome.label]] || '';

                    return (
                        <li className={styles.item} key={state.name || index}>
                            <div className={styles.itemTitle}>
                                {showSeats ? (
                                    <>
                                        <span>{state.name}</span>
                                        <span className={styles.xiwei}> 共{total}席</span>
                                    </>
                                ) : (
                                    <span>{state.name}</span>
                                )}
                                <span className={statusClass}>｜{outcome.label}</span>
                            </div>
                            <div className={styles.track}>
                                <div className={styles.gray} style={{ backgroundColor: outcome.gray }} />
                                {outcome.demWidth > 0 ? <div className={styles.demBar} style={{ width: `${outcome.demWidth}%`, backgroundColor: outcome.demFill }} /> : null}
                                {outcome.othWidth > 0 ? (
                                    <div className={styles.othBar} style={{ left: `${outcome.demWidth}%`, width: `${outcome.othWidth}%`, backgroundColor: outcome.othFill }} />
                                ) : null}
                                {outcome.gopWidth > 0 ? <div className={styles.gopBar} style={{ width: `${outcome.gopWidth}%`, backgroundColor: outcome.gopFill }} /> : null}
                                {outcome.showCount && dem > 0 ? <span className={styles.countLeft}>{dem}</span> : null}
                                {outcome.showCount && oth > 0 ? (
                                    <span className={styles.countMid} style={{ left: `${outcome.demWidth + outcome.othWidth / 2}%` }}>
                                        {oth}
                                    </span>
                                ) : null}
                                {outcome.showCount && gop > 0 ? <span className={styles.countRight}>{gop}</span> : null}
                            </div>
                            {outcome.showMeta ? (
                                <div className={styles.meta}>
                                    <span>民主党</span>
                                    <span>共和党</span>
                                </div>
                            ) : null}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

States.propTypes = {
    data: PropTypes.array,
    type: PropTypes.number,
    updateTime: PropTypes.string,
    refreshing: PropTypes.bool,
    onRefresh: PropTypes.func,
    onlySwing: PropTypes.bool,
    onOnlySwingChange: PropTypes.func,
};

export default errorBoundary(States);
